import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IsentropicService } from '../../isentropic.service';

import * as math from 'mathjs';

@Component({
    selector: 'app-if-paptas',
    templateUrl: './if-paptas.component.html',
    styleUrl: './if-paptas.component.scss',
    standalone: false
})
export class IfPaptasComponent implements OnInit {
  paptasForm: FormGroup | undefined;
  paptasoBool?: boolean;
  ga:string = '';
  ma?:number;
  pa:string = '';
  machMap?:Map<string, number>;

  constructor(private isentropicService: IsentropicService, private fBuilder: FormBuilder) { }

  ngOnInit() {
    this.paptasForm = this.fBuilder.group({
      paptasVal: ['',[
        Validators.required,
        Validators.min(.0000001)
      ]],
      gammaVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
      ]]
    })
  }



  myNewton(func:string, inputIterations:number, inputInitial:number) {
    const iterations = inputIterations || 100;
    const initial = inputInitial || 0;
    const funcCompiled = math.compile(func);
    console.log(funcCompiled);
    const dydx = math.derivative(func, 'x');
  
    let r = initial
    for (let i = 0; i < iterations; i++) {
        r = r - funcCompiled.evaluate({ x: r }) / dydx.evaluate({ x: r })
    }
    return r
  }

  
  machFromPaptas(ga:string, pap:string): number {


    let invM2 = 'x^(-2)';
    let a_as_innards:string = `(1 + ((${ga}-1)/2) * x^2)) / (${ga}+1)/2)`; 
    // let a_as:string = `( ${invM2} *  ${a_as_innards}^((${ga}+1)/(${ga}-1)) ) )`;

    let a_as:string = ` ((1 + x^2 * (${ga}-1)/2)^((${ga}+1)/(${ga}-1)/2))*(((${ga}+1)/2)^-((${ga}+1)/(${ga}-1)/2)) / x`;
    let p_pt = `(1 + x^2 * (${ga}-1)/2)^-(${ga}/(${ga}-1))`;

    // const topG2:string = `(((${ga}+1)/2)^-((${ga}+1)/(${ga}-1)/2)) / x * (1 + x^2 * (${ga}-1)/2)^((${ga}+1)/(${ga}-1)/2) - ${a_as}`;


    const topG3:string = `${a_as} * ${p_pt} - ${pap}`;


    // console.log('new thing: ');
    // console.log(this.myNewton(topG2, 100, guess));
    console.log(topG3);
  
    return this.myNewton(topG3, 100, .001);
  

  }


  onSubmit():void{
    this.paptasoBool = true;
    this.pa = this.paptasForm?.get('paptasVal')?.value;
    this.ga = this.paptasForm?.get('gammaVal')?.value;

    this.ma =  this.machFromPaptas(this.ga, this.pa);
    // console.log(this.ma);
    let myGNum:number = Number(this.ga);
    this.machMap = this.isentropicService.getIsentropic(myGNum, this.ma);
  }

  get machVal() {
    return this.paptasForm?.get('machVal');
  }

  get gammaVal() {
    return this.paptasForm?.get('gammaVal');
  }

  isenMach():number {
    return Number(this.ma);
  }

  isenp_pt() {
    return this.machMap?.get("p_pt");
  }

  isenA_As() {
    return this.machMap?.get("A_A*")
  }

  isenpm() {
    return this.machMap?.get("Prandlt-Meyer");
  }

  isenmach_angle() {
    return this.machMap?.get("mach-angle");
  }
  
  isenT_Tt() {
    return this.machMap?.get("T_Tt");
  }

  isen_cfopt() {
    return this.machMap?.get("C_Fopt");
  }

  isen_rhot() {
    return this.machMap?.get("rho/rhot");
  }


}
